module.exports = __webpack_public_path__ + "img/CM-SL-CA-Volvo-Established.1d4c1d51.jpeg";